const MODULE_NAME = "VIDEO_CONSULTATIONS";
const FETCH_VIDEO_CONSULTATIONS_COUNT_STARTED = MODULE_NAME + 'FETCH_COUNT_STARTED';
const FETCH_VIDEO_CONSULTATIONS_COUNT_COMPLETED = MODULE_NAME + 'FETCH_COUNT_COMPLETED';

export {
  FETCH_VIDEO_CONSULTATIONS_COUNT_STARTED,
  FETCH_VIDEO_CONSULTATIONS_COUNT_COMPLETED
};
